import React from 'react';

import { useDialogNotification } from '../hooks/useDialogNotification';

import { DialogNotificationDialog } from './DialogNotificationDialog';

export const DialogNotificationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const {
    dialogNotification,
    isDialogOpen,
    handleCloseDialog,
    handleMarkAsRead,
  } = useDialogNotification();

  return (
    <>
      {children}

      {dialogNotification && (
        <DialogNotificationDialog
          notification={dialogNotification}
          open={isDialogOpen}
          onClose={handleCloseDialog}
          onMarkAsRead={handleMarkAsRead}
        />
      )}
    </>
  );
};
